import React, { useState } from "react";

import { SectionWrapper } from "../hoc";
import { testimonials } from "../constants";
import { motion } from "framer-motion";
import { fadeIn, textVariant, slideIn } from "../utils/motion";

const Clients = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const handleAccordionClick = (index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  return (
    <div className="space-gradient overflow-hidden w-full">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={fadeIn("right", "spring", 0.5, 0.6)}
        className="gold w-3/5 h-[1px]   "
      ></motion.div>
      <div className="px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] ">
        <div className="pt-16 lg:pt-20 pb-2 lg:pb-4">
          <motion.h2
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("right", "spring", 0.5, 0.6)}
            className="justify-center text-center uppercase text-white text-4xl lg:text-5xl leading-tight md:leading-normal  font-leading mb-10"
          >
            Our Clients{" "}
          </motion.h2>
        </div>
        <div className="lg:hidden mb-10">
          {testimonials.map((testimonial, index) => (
            <motion.div
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={fadeIn("right", "spring", 0.5, 0.6)}
              key={index}
              className={`    rounded-lg cursor-pointer mb-4 ${
                activeIndex === index ? "quote-title" : ""
              }`}
              onClick={() => handleAccordionClick(index)}
            >
              <div className="flex items-start px-4 py-6  text-left bg-black rounded-xl">
                <div className="flex-1 select-none pl-4">
                  <motion.h4
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    variants={textVariant(0.6)}
                    className="uppercase font-medium text-lg leading-normal tracking-widest"
                  >
                    {testimonial.name}
                  </motion.h4>
                  <span className="block pt-2 uppercase font-normal text-xs leading-normal tracking-widest">
                    {testimonial.designation}
                  </span>
                  {testimonial.organization && (
                    <span className="block mt-2 text-xs uppercase tracking-2widest">
                      {testimonial.organization}
                    </span>
                  )}
                </div>
                <div className="w-4 ml-2 plus-icon quote-title self-center">
                  {activeIndex === index ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 36 35"
                      fill="currentColor"
                    >
                      <path
                        className="vline"
                        d="M34.5 15.5c.552 0 1 .895 1 2 0 1.026-.386 1.871-.883 1.987l-.117.013h-33c-.552 0-1-.895-1-2 0-1.026.386-1.871.883-1.987L1.5 15.5h33z"
                      ></path>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 36 35"
                      fill="currentColor"
                    >
                      <path
                        className="vline"
                        d="M34.5 15.5c.552 0 1 .895 1 2 0 1.026-.386 1.871-.883 1.987l-.117.013h-33c-.552 0-1-.895-1-2 0-1.026.386-1.871.883-1.987L1.5 15.5h33z"
                      ></path>
                      <path
                        className="hline"
                        d="M20 34c0 .552-.895 1-2 1-1.026 0-1.871-.386-1.987-.883L16 34V1c0-.552.895-1 2-1 1.026 0 1.871.386 1.987.883L20 1v33z"
                      ></path>
                    </svg>
                  )}
                </div>
              </div>
              {activeIndex === index && (
                <motion.div
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true }}
                  variants={fadeIn("right", "spring", 0, 0.9)}
                  className="px-8 pt-8 text-lg mb-10 bg-transparent"
                >
                  <div className="leading-relaxed tracking-wider text-white text-left">
                  <img src={testimonials[activeIndex].image} className="rounded-xl"/>
                  </div>
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
        <div className="hidden lg:block">
          <div className="flex justify-center pt-8  items-stretch pb-10">
            <div className="w-[45%]">
              <div className="h-full">
                {testimonials.map((testimonial, index) => (
                  <motion.div
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    variants={fadeIn("right", "spring", index * 0.3, 0.6)}
                    key={index}
                    className={`bg-black px-6 py-8 cursor-pointer rounded-xl mb-[20px] uppercase testimonial-item text-left ${
                      activeIndex === index ? "quote-title" : ""
                    }`}
                    onClick={() => handleAccordionClick(index)}
                    style={
                      activeIndex === index ? { pointerEvents: "none" } : {}
                    }
                  >
                    <motion.h4
                      initial="hidden"
                      whileInView="show"
                      viewport={{ once: true }}
                      variants={textVariant(0.6)}
                      className="uppercase font-medium text-lg leading-normal tracking-widest"
                    >
                      {testimonial.name}
                    </motion.h4>
                    <span className="uppercase font-normal text-xs leading-normal tracking-widest">
                      {testimonial.designation}
                    </span>{" "}
                    <br></br>
                    <span className="text-xs uppercase tracking-widest">
                      {testimonial.organization}
                    </span>
                  </motion.div>
                ))}
              </div>
            </div>
            <div className="hidden md:block overflow-hidden w-[55%] ml-[20px] bg-black rounded-2xl">
              <motion.div
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={fadeIn("left", "spring", 0.3, 0.4)}
                className="shadow-2xl h-full rounded-lg text-left"
              >
                {activeIndex !== -1 && (
                  <div className="p-10 text-white">
                    <div className="text-[16px] lg:text-[18px] tracking-wider leading-10 mb-[40px] justify-center flex">
                      <img src={testimonials[activeIndex].image} className="h-auto xl:h-[350px] rounded-xl"/>
                    </div>
                    <span className="quote-title  font-medium uppercase tracking-wider">
                      {testimonials[activeIndex].name}
                    </span>
                    <br></br>
                    <span className="block quote-title mt-[6px] uppercase font-normal text-xs leading-normal tracking-widest">
                      {testimonials[activeIndex].designation}{" "}
                    </span>
                    <span className="quote-title text-xs uppercase tracking-widest">
                      {testimonials[activeIndex].organization}
                    </span>
                  </div>
                )}
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionWrapper(Clients, "clients");
